var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Bold/location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7473 5.63329C13.0473 2.55329 10.3607 1.16663 8.00067 1.16663H7.994C5.64067 1.16663 2.94733 2.54663 2.24733 5.62663C1.46733 9.06663 3.574 11.98 5.48067 13.8133C6.15648 14.4674 7.06013 14.8332 8.00067 14.8333C8.90733 14.8333 9.814 14.4933 10.514 13.8133C12.4207 11.98 14.5273 9.07329 13.7473 5.63329ZM8.00067 8.97329C7.72489 8.97329 7.45182 8.91897 7.19703 8.81344C6.94225 8.7079 6.71075 8.55322 6.51574 8.35822C6.32074 8.16321 6.16605 7.93171 6.06052 7.67693C5.95498 7.42214 5.90067 7.14907 5.90067 6.87329C5.90067 6.59752 5.95498 6.32444 6.06052 6.06966C6.16605 5.81487 6.32074 5.58337 6.51574 5.38837C6.71075 5.19337 6.94225 5.03868 7.19703 4.93315C7.45182 4.82761 7.72489 4.77329 8.00067 4.77329C8.55762 4.77329 9.09176 4.99454 9.48559 5.38837C9.87942 5.7822 10.1007 6.31634 10.1007 6.87329C10.1007 7.43025 9.87942 7.96439 9.48559 8.35822C9.09176 8.75204 8.55762 8.97329 8.00067 8.97329Z",
    fill: "#313131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7986a78eb5d483570a403f7e05b11eb5.svg";
export { ForwardRef as ReactComponent };